// extracted by mini-css-extract-plugin
module.exports = {"favoriteWrapper":"FavoriteIcon_favoriteWrapper__1rCgC","disabled":"FavoriteIcon_disabled__3-W_W","inWishlist":"FavoriteIcon_inWishlist__2x4Ik"};